// extracted by mini-css-extract-plugin
export var animationAbsolute = "_2q-q";
export var animationRelative = "_2q-p";
export var backdropBlur = "_2q-0";
export var detailLabelCell = "_2q-12";
export var detailTable = "_2q-11";
export var detailValueCell = "_2q-13";
export var docIconBox = "_2q-1d";
export var docIconBoxMd = "_2q-1f";
export var docIconBoxSm = "_2q-1e";
export var docTypeRow = "_2q-16";
export var docTypeRowInner = "_2q-17";
export var dropdownMatchDatePicker = "_2q-3";
export var evidenceCardContent = "_2q-1c";
export var fileUploadSpin = "_2q-j";
export var gorgiasOpenButton = "_2q-15 _2q-d";
export var gorgiasTicketCard = "_2q-14";
export var heroModalFooterButton = "_2q-18";
export var hiddenContainer = "_2q-o";
export var iconPrimary = "_2q-1g";
export var iconSecondary = "_2q-1h";
export var iconTertiary = "_2q-1i";
export var integrationCard = "_2q-1";
export var integrationLogoBox = "_2q-2";
export var mainColumnSticky = "_2q-1b";
export var maxWidthContainer = "_2q-19";
export var modalContentBody = "_2q-a";
export var modalHeaderImage = "_2q-5";
export var modalImageLabel = "_2q-7";
export var modalImageOverlay = "_2q-6";
export var modalImageSubtitle = "_2q-9";
export var modalImageTitle = "_2q-8";
export var modalImageWrapper = "_2q-4";
export var modalStickyFooter = "_2q-b";
export var removeButton = "_2q-e";
export var sidebarColumn = "_2q-1a";
export var spinner = "_2q-i";
export var timelineLine = "_2q-y";
export var timelineLineBlack = "_2q-10 _2q-y";
export var timelineLineGray = "_2q-z _2q-y";
export var timelineLineHeight = "_2q-x";
export var tlDotActivate = "_2q-u";
export var tlDotActivateAnim = "_2q-t";
export var tlDotHide = "_2q-s";
export var tlDotHideAnim = "_2q-r";
export var tlLineActivate = "_2q-w";
export var tlLineActivateAnim = "_2q-v";
export var uploadHint = "_2q-n";
export var uploadIconBox = "_2q-k";
export var uploadLabel = "_2q-m";
export var uploadText = "_2q-l";
export var uploadZone = "_2q-f";
export var uploadZoneCursorDefault = "_2q-h";
export var uploadZoneCursorPointer = "_2q-g";
export var uploadedFileRow = "_2q-c";
export var viewButton = "_2q-d";